export const initialState = {
  content: {} as { [id: string]: any },
  appStyleCreated: false,
  error: null as string,
  marketing: {} as { [id: string]: any },
  isDataLoaded: false
};

export type CmsState = Readonly<typeof initialState>;
